// extracted by mini-css-extract-plugin
export default {"Contacts":"styles_Contacts__CWg4G","header":"styles_header__hBK5I","saveButtonsContainer":"styles_saveButtonsContainer__5x-lz","form":"styles_form__mHr3t"};